module.exports = __webpack_public_path__ + "static/img/deepseek-copy.63ca6d48.png";